import Cookies from 'js-cookie';
export const CROSS_DOMAIN_COOKIE_PREFIX = 'hb_marketing_storage_';
function transformJsonData(data) {
    try {
        return JSON.parse(data);
    }
    catch {
        return data;
    }
}
export const storeCrossDomainCookieInStorage = (logger) => {
    try {
        const crossedDomainCookies = getCrossedDomainCookies(logger);
        crossedDomainCookies.forEach(({ storageType, name, value, originalCookieName }) => {
            try {
                if (typeof window !== 'undefined' && window[storageType]) {
                    const storage = window[storageType];
                    storage.setItem(name, JSON.stringify(value));
                    Cookies.remove(originalCookieName);
                }
            }
            catch (error) {
                logger?.error(error, {
                    message: 'Failed to store cross-domain cookie in storage',
                    context: { storageType, name }
                });
            }
        });
    }
    catch (error) {
        logger?.error(error, {
            message: 'Failed to process cross-domain cookies'
        });
    }
};
const getCrossedDomainCookies = (logger) => {
    const cookies = getCookiesByPrefix(CROSS_DOMAIN_COOKIE_PREFIX);
    return Object.entries(cookies)
        .map(([cookieName, value]) => {
        try {
            // Split the cookie name into parts
            const parts = cookieName.split('_');
            const storageIndex = parts.indexOf('storage');
            if (storageIndex === -1 || storageIndex + 1 >= parts.length) {
                logger?.error(new Error('Invalid cookie name format for cross-domain cookie'), { cookieName });
                return null;
            }
            // Get the storage type
            const storageType = parts[storageIndex + 1];
            if (storageType !== 'localStorage' &&
                storageType !== 'sessionStorage') {
                logger?.error(Error('Invalid storage type in cross-domain cookie'), { cookieName, storageType });
                return null;
            }
            // Get the name of the cookie
            const name = parts.slice(storageIndex + 2).join('_');
            if (!name) {
                logger?.error(new Error('No storage key name found in cross-domain cookie'), { cookieName });
                return null;
            }
            // Get the value of the cookie
            let parsedValue;
            if (typeof value === 'string') {
                parsedValue = transformJsonData(value);
            }
            return {
                storageType: storageType,
                name,
                value: parsedValue,
                originalCookieName: cookieName
            };
        }
        catch (error) {
            logger?.error(error, {
                message: 'Failed to parse cross-domain cookie',
                cookieName
            });
            return null;
        }
    })
        .filter(Boolean);
};
export const getCookiesByPrefix = (prefix, logger) => {
    const cookies = {};
    if (typeof document === 'undefined') {
        return cookies;
    }
    try {
        const allCookies = Cookies.get();
        Object.entries(allCookies).forEach(([name, value]) => {
            if (name && value && name.startsWith(prefix)) {
                cookies[name] = value;
            }
        });
    }
    catch (error) {
        logger?.error(error, { message: 'Failed to read cookies' });
    }
    return cookies;
};
export const getCookieNameByKey = (key) => {
    return `${CROSS_DOMAIN_COOKIE_PREFIX}sessionStorage_${key}`;
};
//# sourceMappingURL=cookie.util.js.map